export default __webpack_public_path__ + "static/media/practics-banner.6fe2c2b5.png";